<template>
  <section>
    <text-row v-if="proforma.total_vat_free !== null"
              left="Totaal BTW vrij"
              :right="formatPriceToEuroString(proforma.total_vat_free)"/>
    <text-row v-if="proforma.total_excl_vat !== null"
              left="Totaal ex. BTW"
              :right="formatPriceToEuroString(proforma.total_excl_vat)"/>
    <text-row v-if="
                proforma.total_excl_vat !== null && proforma.total_incl_vat !== null
              "
              :left="`BTW over ${formatPriceToEuroString(proforma.total_excl_vat)}`"
              :right="formatPriceToEuroString(proforma.total_incl_vat - proforma.total_excl_vat)"/>
  </section>
</template>

<script setup lang="ts">
import TextRow from '@app/components/TextRow.vue';
import { formatPriceToEuroString } from '@pidz/utils';
import { Proforma } from '../types';

defineProps<{
  proforma: Proforma;
}>();
</script>
